interface WorkexperienceItemProps {
  Icon: string;
  CompanyName: string;
  Date: string;
  Location: string;
  Points: string[];
}

function WorkexperienceItem({
  Icon,
  CompanyName,
  Date,
  Location,
  Points,
}: WorkexperienceItemProps) {
  return (
    <div className="Workexperience-Item">
      <div className="Workexperience-Item-Header">
        <img className="Workexperience-Item-Icon" src={Icon} alt="" />
        <div className="Workexperience-Item-Info">
          <span className="Workexperience-Item-Info-Company">
            {CompanyName}
          </span>
          <span className="Workexperience-Item-Info-Date">{Date}</span>
          <span className="Workexperience-Item-Info-Location">{Location}</span>
        </div>
      </div>
      <ul className="Workexperience-Item-List">
        {Points.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

export default WorkexperienceItem;
